import jwt from "jsonwebtoken";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => {
    if (error.name === "NavigationDuplicated") {
      return {
        event: "NavigationDuplicated",
      };
    }
  });
};

const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch((error) => {
    if (error.name === "NavigationDuplicated") {
      return {
        event: "NavigationDuplicated",
      };
    }
  });
};

const routes = [
  // 프로모션
  {
    path: "/",
    name: "Home",
    component: () => import("../views/common/Home.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/page-error",
    name: "PageError",
    component: () => import("../views/PageError.vue"),
  },
  // 서버 에러
  {
    path: "/server-error",
    name: "ServerError",
    component: () => import("../views/ServerError.vue"),
  },
  /* ========= 고객 화면 ========= */
  {
    path: "/client",
    name: "Client",
    redirect: "/client/login",
    component: () => import("../views/client"),
    children: [
      {
        path: "social-redirect/:provider",
        name: "ClientSocialRedirect",
        component: () => import("../views/client/auth/SocialRedirect.vue"),
      },
      {
        path: "intro",
        name: "Intro",
        component: () => import("../views/client/intro.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-step-01",
        name: "EstimateStep01",
        component: () =>
          import("../views/client/estimate-step/EstimateStep01.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-02",
        name: "EstimateStep02",
        component: () =>
          import("../views/client/estimate-step/EstimateStep02.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-03",
        name: "EstimateStep03",
        component: () =>
          import("../views/client/estimate-step/EstimateStep03.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-04",
        name: "EstimateStep04",
        component: () =>
          import("../views/client/estimate-step/EstimateStep04.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-05",
        name: "EstimateStep05",
        component: () =>
          import("../views/client/estimate-step/EstimateStep05.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-06",
        name: "EstimateStep06",
        component: () =>
          import("../views/client/estimate-step/EstimateStep06.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-07",
        name: "EstimateStep07",
        component: () =>
          import("../views/client/estimate-step/EstimateStep07.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-08",
        name: "EstimateStep08",
        component: () =>
          import("../views/client/estimate-step/EstimateStep08.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-10",
        name: "EstimateStep10",
        component: () =>
          import("../views/client/estimate-step/EstimateStep10.vue"),
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: "estimate-step-11",
        name: "EstimateStep11",
        component: () =>
          import("../views/client/estimate-step/EstimateStep11.vue"),
        meta: {
          requiresAuth: false,
        },
      },

      // 견적서 수신함
      {
        path: "estimate-view-01",
        name: "EstimateView01",
        component: () =>
          import("../views/client/estimate-view/EstimateView01.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-view-02/:id",
        name: "EstimateView02",
        component: () =>
          import("../views/client/estimate-view/EstimateView02.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-view-03/:id",
        name: "EstimateView03",
        component: () =>
          import("../views/client/estimate-view/EstimateView03.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-view-04/:id",
        name: "EstimateView04",
        component: () =>
          import("../views/client/estimate-view/EstimateView04.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 이용약관, 개인정보처리방침
      {
        path: "terms",
        name: "Terms",
        component: () => import("../views/common/Terms.vue"),
      },
      // 로그인
      {
        path: "login",
        name: "Login",
        component: () => import("../views/client/auth/Login.vue"),
      },
      // 회원가입
      {
        path: "join",
        name: "Join",
        component: () => import("../views/client/auth/Join.vue"),
      },
      // 아이디찾기
      {
        path: "findid",
        name: "FindId",
        component: () => import("../views/client/auth/FindId.vue"),
      },
      // 아이디찾기 결과
      {
        path: "findid-result",
        name: "FindIdResult",
        component: () => import("../views/client/auth/FindIdResult.vue"),
      },
      // 비밀번호 찾기
      {
        path: "findpw",
        name: "FindPw",
        component: () => import("../views/client/auth/FindPw.vue"),
      },
      // 비밀번호 찾기 결과
      {
        path: "findpw-result",
        name: "FindPwResult",
        component: () => import("../views/client/auth/FindPwResult.vue"),
      },
      // 비밀번호 찾기 결과
      {
        path: "changepw-result",
        name: "ChangePwResult",
        component: () => import("../views/client/auth/ChangePwResult.vue"),
      },
      // 마이페이지
      {
        path: "mypage",
        name: "Mypage",
        component: () => import("../views/client/Mypage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 내 정보 수정
      {
        path: "mypage-edit",
        name: "MypageEdit",
        component: () => import("../views/client/MypageEdit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 공지사항
      {
        path: "notice",
        name: "Notice",
        component: () => import("../views/common/Notice.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 공지사항 디테일
      {
        path: "notice/detail",
        name: "NoticeDetail",
        component: () => import("../views/common/NoticeDetail.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },

  /* ========= 대리점 화면 ========= */
  {
    path: "/dealer",
    name: "Dealer",
    redirect: "/dealer/login",
    component: () => import("../views/dealer"),
    children: [
      {
        path: "social-redirect/:provider",
        name: "DealerSocialRedirect",
        component: () => import("../views/dealer/auth/SocialRedirect.vue"),
      },
      {
        path: "intro",
        name: "StaffIntro",
        component: () => import("../views/dealer/intro.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 이용약관, 개인정보처리방침
      {
        path: "terms",
        name: "StaffTerms",
        component: () => import("../views/common/Terms.vue"),
      },
      // 로그인
      {
        path: "login",
        name: "StaffLogin",
        component: () => import("../views/dealer/auth/Login.vue"),
      },
      // 회원가입
      {
        path: "join-01",
        name: "StaffJoin01",
        component: () => import("../views/dealer/auth/Join01.vue"),
      },
      {
        path: "join-02",
        name: "StaffJoin02",
        component: () => import("../views/dealer/auth/Join02.vue"),
      },
      {
        path: "join-02-dealer",
        name: "Join02Dealer",
        component: () => import("../views/dealer/auth/Join02Dealer.vue"),
      },
      {
        path: "join-03",
        name: "StaffJoin03",
        component: () => import("../views/dealer/auth/Join03.vue"),
      },
      {
        path: "join-03-dealer",
        name: "Join03Dealer",
        component: () => import("../views/dealer/auth/Join03Dealer.vue"),
      },
      {
        path: "join-complete",
        name: "JoinComplete",
        component: () => import("../views/dealer/auth/JoinComplete.vue"),
      },
      // 아이디찾기
      {
        path: "findid",
        name: "StaffFindId",
        component: () => import("../views/dealer/auth/FindId.vue"),
      },
      // 아이디찾기 결과
      {
        path: "findid-result",
        name: "StaffFindIdResult",
        component: () => import("../views/dealer/auth/FindIdResult.vue"),
      },
      // 비밀번호 찾기
      {
        path: "findpw",
        name: "StaffFindPw",
        component: () => import("../views/dealer/auth/FindPw.vue"),
      },
      // 비밀번호 찾기 결과
      {
        path: "findpw-result",
        name: "StaffFindPwResult",
        component: () => import("../views/dealer/auth/FindPwResult.vue"),
      },
      // 비밀번호 변경 결과
      {
        path: "changepw-result",
        name: "StaffChangePwResult",
        component: () => import("../views/dealer/auth/ChangePwResult.vue"),
      },
      // 마이페이지
      {
        path: "mypage",
        name: "StaffMypage",
        component: () => import("../views/dealer/Mypage.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 내 정보 수정
      {
        path: "mypage-edit",
        name: "StaffMypageEdit",
        component: () => import("../views/dealer/MypageEdit.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 공지사항
      {
        path: "notice",
        name: "StaffNotice",
        component: () => import("../views/common/StaffNotice.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 공지사항 디테일
      {
        path: "notice/detail",
        name: "StaffNoticeDetail",
        component: () => import("../views/common/StaffNoticeDetail.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-list-new01",
        name: "StaffEstimateListNew01",
        component: () =>
          import("../views/dealer/estimate/EstimateListNew01.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-list-new02",
        name: "StaffEstimateListNew02",
        component: () =>
          import("../views/dealer/estimate/EstimateListNew02.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-list-new03",
        name: "StaffEstimateListNew03",
        component: () =>
          import("../views/dealer/estimate/EstimateListNew03.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      // 견적서 수신함
      {
        path: "estimate-list-progress",
        name: "StaffEstimateListProgress",
        component: () =>
          import("../views/dealer/estimate-view/EstimateListProgress.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "estimate-confirm/:id",
        name: "StaffEstimateConfirm",
        component: () =>
          import("../views/dealer/estimate-view/EstimateConfirm.vue"),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // if (savedPosition) {
    //   return new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //       resolve(savedPosition);
    //     }, 0);
    //   });
    // } else {
    return { x: 0, y: 0 };
    // }
  },
});

router.beforeEach(async (to, from, next) => {
  if (store.getters.isUser) {
    // 유저 정보가 있을 경우

    if (!store.getters.hasNeededInfo) {
      // 필수정보 입력이 안되어있을 경우
      if (
        [
          "/client/mypage-edit",
          "/dealer/mypage-edit",
          "/client/changepw-result",
          "/dealer/changepw-result",
        ].includes(to.path)
      ) {
        // 내 정보 수정 페이지로 강제 이동
        return next();
      } else {
        if (store.getters.isClient) {
          return next({
            name: "MypageEdit",
          });
        }

        if (store.getters.isDealer) {
          return next({
            name: "StaffMypageEdit",
          });
        }
      }
    }

    if (!store.getters.isVerified) {
      // 심사 승인이 안되어있을 경우
      if (
        [
          "/dealer/mypage",
          "/dealer/mypage-edit",
          "/client/changepw-result",
          "/dealer/changepw-result",
        ].includes(to.path)
      ) {
        // 내 정보 페이지로 강제 이동
        return next();
      } else {
        if (store.getters.isDealer) {
          return next({
            name: "StaffMypage",
          });
        }
      }
    }

    if (to.meta.requiresAuth) {
      // 인증이 필요한 페이지로 이동시

      if (store.getters.isClient) {
        // 고객일 경우 딜러 페이지로 이동 못하게 막기
        if (to.path.includes("/dealer/")) {
          return next({
            name: "Home",
          });
        }
      }

      if (store.getters.isDealer) {
        // 대리점일 경우 고객 페이지로 이동 못하게 막기
        if (to.path.includes("/client/")) {
          return next({
            name: "StaffEstimateListNew01",
          });
        }
      }

      return next();
    } else {
      if (to.path === "/client/login") {
        // 로그인 페이지로 이동 시 메인 페이지로 이동
        return next({
          name: "Home",
        });
      }

      if (to.path === "/dealer/login") {
        // 로그인 페이지로 이동 시 메인 페이지로 이동
        return next({
          name: "StaffEstimateListNew01",
        });
      }

      return next();
    }
  } else {
    // 유저 정보가 없을 경우
    if (process.env.VUE_APP_TOKEN_NAME === undefined) {
      alert(
        "토큰 이름이 없습니다. .env 파일과 serve --mode 옵션을 확인해주세요.",
      );
      throw new Error(
        "토큰 이름이 없습니다. .env 파일과 serve --mode 옵션을 확인해주세요.",
      );
    }

    // 토큰 상태 체크
    const APP_TOKEN =
      window.localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || null;
    const decodedJWT = jwt.decode(APP_TOKEN);

    if (decodedJWT && decodedJWT.exp > new Date().getTime() / 1000) {
      // 토큰이 있고 만료되지 않았을 경우 유저 정보 가져오기
      // console.log('user_type:', decodedJWT.user_type);

      await store.dispatch("userDetail", {
        user_type: decodedJWT.user_type,
      });

      if (!store.getters.hasNeededInfo) {
        // 필수정보 입력이 안되어있을 경우
        if (
          [
            "/client/mypage-edit",
            "/dealer/mypage-edit",
            "/client/changepw-result",
            "/dealer/changepw-result",
          ].includes(to.path)
        ) {
          // 내 정보 수정 페이지로 강제 이동
          return next();
        } else {
          if (store.getters.isClient) {
            return next({
              name: "MypageEdit",
            });
          }

          if (store.getters.isDealer) {
            return next({
              name: "StaffMypageEdit",
            });
          }
        }
      }

      if (!store.getters.isVerified) {
        // 심사 승인이 안되어있을 경우
        if (
          [
            "/dealer/mypage",
            "/dealer/mypage-edit",
            "/dealer/changepw-result",
          ].includes(to.path)
        ) {
          // 내 정보 페이지로 강제 이동
          return next();
        } else {
          if (store.getters.isDealer) {
            return next({
              name: "StaffMypage",
            });
          }
        }
      }

      if (to.meta.requiresAuth) {
        // 인증이 필요한 페이지로 이동시
        if (store.getters.isClient) {
          // 고객일 경우 딜러 페이지로 이동 못하게 막기
          if (to.path.includes("/dealer/")) {
            return next({
              name: "Home",
            });
          }
        }

        if (store.getters.isDealer) {
          // 대리점일 경우 고객 페이지로 이동 못하게 막기
          if (to.path.includes("/client/")) {
            return next({
              name: "StaffEstimateListNew01",
            });
          }
        }

        return next();
      } else {
        if (to.path === "/") {
          // 로그인 페이지로 이동 시 메인 페이지로 이동
          if (store.getters.isClient) {
            return next({
              name: "Home",
            });
          }

          if (store.getters.isDealer) {
            return next({
              name: "StaffEstimateListNew01",
            });
          }

          throw new Error("user_type이 없습니다.");
        } else {
          // 로그인 페이지가 아닐 경우
          return next();
        }
      }
    } else {
      // 토큰이 없거나 만료되었을 경우
      if (to.meta.requiresAuth) {
        // 인증이 필요한 페이지로 이동시 로그인 페이지로 이동
        if (to.path.includes("/dealer/")) {
          return next({
            name: "StaffLogin",
            query: {
              redirect_from: to.fullPath,
            },
          });
        }

        if (to.path.includes("/client/")) {
          return next({
            name: "Login",
            query: {
              redirect_from: to.fullPath,
            },
          });
        }
      } else {
        return next();
      }
    }
  }
});

export default router;
